import {Record, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import {type Institution} from './model';

export interface CheckinPincodesModalProps {
    readonly isVisible: boolean;
    readonly isFetching: boolean;
    readonly institutions: List<Institution>;
}
export class CheckinPincodesModalState extends Record<CheckinPincodesModalProps>({
    isVisible: false,
    isFetching: false,
    institutions: List(),
}) {}

export default makeReducer<CheckinPincodesModalState>(
    [
        match(
            Actions.show,
            () =>
                new CheckinPincodesModalState({
                    isVisible: true,
                }),
        ),
        match(Actions.hide, state =>
            state.merge({
                isVisible: false,
            }),
        ),
        match(Actions.fetchPincodes, state =>
            state.merge({
                isFetching: true,
            }),
        ),
        match(Actions.fetchPincodesSuccess, (state, {payload}) =>
            state.merge({
                isFetching: false,
                institutions: payload.institutions,
            }),
        ),
        match(Actions.fetchPincodesFailed, state =>
            state.merge({
                isFetching: false,
            }),
        ),
    ],
    new CheckinPincodesModalState(),
);
